import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/audit-logs")({
  component: Outlet,
});
